import { DiLinux, DiWindows, DiJsBadge } from "react-icons/di";
import { IoPrintOutline } from "react-icons/io5";
import { FaPhp } from "react-icons/fa6";
import { BsRouter, BsWifi } from "react-icons/bs";
import { BiLogoHtml5, BiLogoCss3 } from "react-icons/bi";
import { SiGimp, SiInkscape } from "react-icons/si";
import { GrMysql } from "react-icons/gr";
import { SiApache } from "react-icons/si";

export const Icons = {
  LinuxIcon: DiLinux,
  WindowsIcon: DiWindows,
  PhpIcon: FaPhp,
  JsIcon: DiJsBadge,
  PrinterIcon: IoPrintOutline,
  RouterIcon: BsRouter,
  WifiIcon: BsWifi,
  HtmlIcon: BiLogoHtml5,
  CssIcon: BiLogoCss3,
  GimpIcon: SiGimp,
  SqlIcon: GrMysql,
  InkscapeIcon: SiInkscape,
  WwwSrvLinIcon: SiApache
};